import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import loadScripts from '../../../dassets/js/custom';
class Executor extends Component {
    componentDidMount() {
      loadScripts();
    }
    constructor(props) {
        super(props);

        this.saveAndContinue = this.saveAndContinue.bind(this);
        this.onChangePassport = this.onChangePassport.bind(this);
        this.onChangeSignature = this.onChangeSignature.bind(this);
        this.data = {
            passport: null,
            signature: null
        }
    }

    saveAndContinue(e) {
        e.preventDefault()

        // Get values via this.refs
        let data = {
            title: this.refs.title.value,
            gender: this.refs.gender.value,
            surname: this.refs.surname.value,
            first_name: this.refs.first_name.value,
            other_name: this.refs.other_name.value,
            email: this.refs.email.value,
            dob: this.refs.dob.value,
            marital_status: this.refs.marital_status.value,
            mother_maiden_name: this.refs.mother_maiden_name.value,
            phone1: this.refs.phone1.value,
            phone2: this.refs.phone2.value,
            passport: this.data.passport,
            signature: this.data.signature,
            signature_path: `eform_signature_${this.refs.surname.value}_${this.refs.first_name.value}_${new Date().getTime()}.png`,
            passport_path: `eform_passport_${this.refs.surname.value}_${this.refs.first_name.value}_${new Date().getTime()}.png`,
        }

        this.props.saveValues(data, 'executor')
        this.props.nextStep()
    }

    onChangePassport(e) {
        const fileTypes = ['image/png', 'image/gif', 'image/jpeg'];

        let file = e.target.files[0];
        if (fileTypes.every(extension => file.type !== extension)) {
            toast.error(`The file ${file.type} extension is not supported`);
            return
        }
        this.data.passport = file;
    }

    onChangeSignature(e) {
        const fileTypes = ['image/png', 'image/gif', 'image/jpeg'];

        let file = e.target.files[0];
        if (fileTypes.every(extension => file.type !== extension)) {
            toast.error(`The file ${file.type} extension is not supported`);
            return
        }
        this.data.signature = file;
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-danger mb-4">Executor 1</h4>
                                <form onSubmit={this.saveAndContinue}>
                                    <div className="row">
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Title<span className="text-danger">*</span></label>
                                            <select ref="title" required className="form-control" defaultValue={this.props.fieldValues.title}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Mr">Mr</option>
                                                <option value="Miss">Miss</option>
                                                <option value="Mrs">Mrs</option>
                                                <option value="Chief">Chief</option>
                                                <option value="Dr.">Dr.</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Surname<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="surname" placeholder="Surname" defaultValue={this.props.fieldValues.surname} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>First Name<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="first_name" placeholder="First Name" defaultValue={this.props.fieldValues.first_name} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Other Name</label>
                                            <Form.Control type="text" className="form-control" ref="other_name" placeholder="Other Name" defaultValue={this.props.fieldValues.other_name} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Gender<span className="text-danger">*</span></label>
                                            <select ref="gender" required className="form-control" defaultValue={this.props.fieldValues.gender}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Email Address<span className="text-danger">*</span></label>
                                            <Form.Control type="email" className="form-control" ref="email" placeholder="Email Address" defaultValue={this.props.fieldValues.email} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Date of Birth<span className="text-danger">*</span></label>
                                            <Form.Control type="date" className="form-control" ref="dob" placeholder="Date of Birth" defaultValue={this.props.fieldValues.dob} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Marital Status<span className="text-danger">*</span></label>
                                            <select ref="marital_status" required className="form-control" defaultValue={this.props.fieldValues.marital_status}>
                                                <option value="" hidden>Select...</option>
                                                <option value="N/A">N/A</option>
                                                <option value="Single">Single</option>
                                                <option value="Married">Married</option>
                                                <option value="Divorced">Divorced</option>
                                                <option value="Widowed">Widowed</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Mother's Maiden Name<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="mother_maiden_name" placeholder="Mother's Maiden Name" defaultValue={this.props.fieldValues.mother_maiden_name} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Mobile No<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control uint" ref="phone1" placeholder="Mobile No" defaultValue={this.props.fieldValues.phone1} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Alternative No</label>
                                            <Form.Control type="text" className="form-control uint" ref="phone2" placeholder="Alternative No" defaultValue={this.props.fieldValues.phone2} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label htmlFor="attachments"><i className="fa fa-paperclip"></i> Passport<span className="text-danger">*</span></label>
                                            <Form.Control onChange={this.onChangePassport} type="file" className="form-control" ref="passport" accept=".jpeg,.jpg,.gif,.png" required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label htmlFor="attachments"><i className="fa fa-paperclip"></i> Signature<span className="text-danger">*</span></label>
                                            <Form.Control onChange={this.onChangeSignature} type="file" className="form-control" ref="attachments" accept=".jpeg,.jpg,.gif,.png" required />
                                        </Form.Group>
                                    </div>
                                    <button onClick={this.props.previousStep} type="button" className="btn btn-primary mr-2">Previous</button>
                                    <button type="submit" className="btn btn-primary mr-2">Save and Continue</button>
                                </form>
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Executor;